<app-mkt-modal2 *ngIf="dialogContent" [showModal]="showModal">
    <div class="citishop-speedbump">
        <div class="citishop-speedbump__close">
            <button class="citishop-speedbump__close__button" type="button" aria-label="Close" (click)="closeModal(['close_icon', 'Close'])" #initialFocus></button>
        </div>
        <div class="citishop-speedbump__body">
            <img class="citishop-speedbump__body__image" [cache]="imageURL" [lazyload]="imageURL" alt="" />
            <h1 class="citishop-speedbump__body__header" [innerHTML]="header | safeHtml"></h1>
            <div class="citishop-speedbump__body__content">
                <div class="sub-announcement sub-announcement-font-style" [innerHTML]="announcement | safeHtml"></div>
                <div class="sub-announcement" [innerHTML]="informationHeader | safeHtml"></div>
                <div [innerHTML]="informationContent | safeHtml"></div>
            </div>
        </div>
        <div class="citishop-speedbump__divider"><hr /></div>
        <div class="citishop-speedbump__footer">
            <a role="button" (click)="submitEmit.emit(['submit', speedBumpButtonText])" cdsButton="primary" class="" [href]="speedBumpURL" [innerHTML]="speedBumpButtonText | safeHtml"></a>
            <a role="button" (click)="closeModal(['close_button', closeButtonText])" href="javascript:void(0)" class="btn btn-secondary" [innerHTML]="closeButtonText | safeHtml"></a>
        </div>
    </div>
</app-mkt-modal2>